import { ref } from '@vue/composition-api'
import store from '@/store'
import Blog from '@/services/Blog'

const captureError = (error) => {
  switch (error) {
    case 404:
      return `${error} - Página não encontrada`

    default:
      break
  }
}

const getPosts = () => {
  const posts = ref([])
  const error = ref(null)

  const load = async () => {
    store.dispatch('home/setOverlayLoading', true)
    try {
      const res = await Blog.getPosts()
      posts.value = res.data
      error.value = null
      store.dispatch('home/setOverlayLoading', false)
    } catch (err) {
      error.value = captureError(err.response.status)
      console.log(error.value)
      store.dispatch('home/setOverlayLoading', false)
    }
  }

  return { posts, error, load }
}

export default getPosts
